// Module
var code = "<template>\n  <require from=\"../waste-matrix-view\"></require>\n\n  <waste-matrix-view erp-system-id.bind=\"1\"></waste-matrix-view>\n</template>";
// Exports
export default code;